const Loading = () => {
    return <div className="spinner-border text-danger" role="status">
    </div>
}

export default Loading;